"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _oauth = require("@/api/oauth");
var _jsMd = _interopRequireDefault(require("js-md5"));
var _store = _interopRequireDefault(require("store2"));
var _vuex = require("vuex");
var _lodash = _interopRequireDefault(require("lodash"));
const storage = _store.default.namespace('page_user_login');
const cachePasswordKey = 'is_remember_password';
var _default = exports.default = {
  name: 'UserLogin',
  // 账号密码登录
  data() {
    const {
      password,
      account
    } = storage.get(cachePasswordKey, {
      password: '',
      account: ''
    });
    return {
      isRememberPassword: !!password,
      form: {
        account,
        password,
        grantType: 'captcha',
        scope: 'all',
        type: 'account',
        code: '',
        // 验证码code，赋值给请求头的Captcha-Code
        key: '' // 验证码key，赋值给请求头的Captcha-Key
      },
      tenantInfo: this.$store.state.user.tenantInfo || {},
      captchaImg: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
      rules: {
        account: [{
          required: true,
          message: '请输入登录账号',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入登录密码',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入图片验证码',
          trigger: 'blur'
        }]
      },
      loading: false,
      tenantList: [],
      // 同一个用户存在多租户的情况
      /** @type {boolean} 正在租户信息 */
      isTenantInfoLoading: false
    };
  },
  created() {
    // 获取租户信息
    this.initTenantInfo();
  },
  methods: {
    ...(0, _vuex.mapActions)(['LoginSuccess', 'GetTenantInfo']),
    onSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.loading = true;
            const params = _lodash.default.cloneDeep(this.form);
            const password = params.password;
            params.password = (0, _jsMd.default)(password);
            if (_lodash.default.isEmpty(this.tenantInfo)) {
              // try again in case the network problems...
              await this.initTenantInfo();
            }
            const res = await (0, _oauth.postUserLogin)({
              ...params,
              tenantId: this.tenantInfo.tenantId
            });
            if (res.length > 1) {
              this.tenantList = res;
            } else {
              this.LoginSuccess(Array.isArray(res) ? res[0] : res);
            }

            // saving passwd...
            if (this.isRememberPassword) {
              // saved password is without MD5 encoded
              storage.set(cachePasswordKey, {
                account: params.account,
                password,
                __is_password_encoded: false
              });
            } else {
              storage.remove(cachePasswordKey);
            }
          } finally {
            this.loading = false;
          }
        }
      });
    },
    handleSelectTenant(item) {
      this.LoginSuccess(item);
    },
    async initTenantInfo() {
      try {
        this.isTenantInfoLoading = true;
        const res = await this.GetTenantInfo();
        this.$store.commit('SET_TENANT_INFO', res);
        this.tenantInfo = res;
      } finally {
        this.isTenantInfoLoading = false;
      }
    }
  }
};